module.exports = __webpack_public_path__ + "img/qr-corner.0fa6cc00.png";